import { defineMessages } from 'react-intl';

const messages = defineMessages({
  card: {
    id: 'junts_card',
    defaultMessage: 'Junts Card',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  Target: {
    id: 'Target',
    defaultMessage: 'Target',
  },
});

export const cardSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.card),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'href'],
      },
    ],

    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
      },
      href: {
        title: props.intl.formatMessage(messages.Target),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: [
          'Title',
          'head_title',
          'Description',
          'hasPreviewImage',
          'image_field',
          'image_scales',
          '@type',
        ],
        allowExternals: true,
      },
    },
    required: ['href'],
  };
};
